import React from "react";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid-pro";

/**
 * Drop-in replacement for MUI's default GridToolbar with the built-in export
 * button removed — export is handled by this app's custom export feature.
 */
const GridToolbarNoExport = React.memo(() => (
  <GridToolbarContainer>
    <GridToolbarColumnsButton />
    <GridToolbarFilterButton />
    <GridToolbarDensitySelector />
  </GridToolbarContainer>
));

GridToolbarNoExport.displayName = "GridToolbarNoExport";

export default GridToolbarNoExport;
